// Apps
import a3nom from 'assets/images/appStore/icons/a3nom.svg'
import appleCalendarIcon from 'assets/images/appStore/icons/apple_calendar.svg'
import atsIcon from 'assets/images/appStore/icons/ats.svg'
import atsCareersPageIcon from 'assets/images/appStore/icons/ats_careers_page.svg'
import atsIdealdisc from 'assets/images/appStore/icons/ats_idealdisc.svg'
import atsWhatsapp from 'assets/images/appStore/icons/ats_whatsapp.svg'
import breezyIcon from 'assets/images/appStore/icons/breezy.svg'
import cobeeIcon from 'assets/images/appStore/icons/cobee.svg'
import competenciesIcon from 'assets/images/appStore/icons/competencies.svg'
import complaintsIcon from 'assets/images/appStore/icons/complaints.svg'
import datev from 'assets/images/appStore/icons/datev.svg'
import deskyIcon from 'assets/images/appStore/icons/desky.svg'
import documentTemplatesIcon from 'assets/images/appStore/icons/document_templates.svg'
import employeeChatWhatsApp from 'assets/images/appStore/icons/employee_chat_whatsapp.svg'
import employeeOnboardingIcon from 'assets/images/appStore/icons/employee_onboarding.svg'
import enpsIcon from 'assets/images/appStore/icons/enps.svg'
import expensesIcon from 'assets/images/appStore/icons/expenses.svg'
import financeIcon from 'assets/images/appStore/icons/finance.svg'
import gmailIcon from 'assets/images/appStore/icons/gmail.svg'
import goalsIcon from 'assets/images/appStore/icons/goals.svg'
import googleCalendarIcon from 'assets/images/appStore/icons/google_calendar.svg'
// Integrations
import growthPlansIcon from 'assets/images/appStore/icons/growth_plans.svg'
import indeedIcon from 'assets/images/appStore/icons/indeed.svg'
import joinIcon from 'assets/images/appStore/icons/join.svg'
import linkedinIcon from 'assets/images/appStore/icons/linkedin.svg'
import linkedinLimitedListingsIcon from 'assets/images/appStore/icons/linkedin_limited_listings.svg'
import outlookIcon from 'assets/images/appStore/icons/outlook.svg'
import outlookCalendarIcon from 'assets/images/appStore/icons/outlook_calendar.svg'
import paierh from 'assets/images/appStore/icons/paierh.svg'
import payflowIcon from 'assets/images/appStore/icons/payflow.svg'
import payrollIcon from 'assets/images/appStore/icons/payroll.svg'
import performanceV2Icon from 'assets/images/appStore/icons/performance_v2.svg'
import recruiteeIcon from 'assets/images/appStore/icons/recruitee.svg'
import shiftManagementIcon from 'assets/images/appStore/icons/shift_management.svg'
import silae from 'assets/images/appStore/icons/silae.svg'
import slackIcon from 'assets/images/appStore/icons/slack.svg'
import surveysIcon from 'assets/images/appStore/icons/surveys.svg'
import tasksManagementIcon from 'assets/images/appStore/icons/tasks_management.svg'
import timeTrackingIcon from 'assets/images/appStore/icons/time_tracking.svg'
import trainingsIcon from 'assets/images/appStore/icons/trainings.svg'
import zapierIcon from 'assets/images/appStore/icons/zapier.svg'
import zucchetti from 'assets/images/appStore/icons/zucchetti.svg'

const ICONS: Record<string, string> = {
  payroll_integrations_a3nom: a3nom,
  payroll_integrations_a3innuva: a3nom,
  payroll_integrations_datev_api: datev,
  payroll_integrations_paierh: paierh,
  payroll_integrations_silae: silae,
  payroll_integrations_zucchetti: zucchetti,
  payroll_integrations_datev_lauds: datev,
  ats: atsIcon,
  ats_careers_page: atsCareersPageIcon,
  tasks_management: tasksManagementIcon,
  shift_management: shiftManagementIcon,
  time_tracking: timeTrackingIcon,
  expenses: expensesIcon,
  expenses_v2: expensesIcon,
  finance: financeIcon,
  payroll_bundle: payrollIcon,
  google_calendar: googleCalendarIcon,
  apple_calendar: appleCalendarIcon,
  outlook_calendar: outlookCalendarIcon,
  zapier: zapierIcon,
  join: joinIcon,
  cobee: cobeeIcon,
  slack: slackIcon,
  surveys: surveysIcon,
  performance_v2: performanceV2Icon,
  gmail: gmailIcon,
  outlook: outlookIcon,
  breezy: breezyIcon,
  desky: deskyIcon,
  recruitee: recruiteeIcon,
  indeed: indeedIcon,
  linkedin: linkedinIcon,
  linkedin_limited_listings: linkedinLimitedListingsIcon,
  payflow: payflowIcon,
  goals: goalsIcon,
  document_templates: documentTemplatesIcon,
  trainings_custom_table: trainingsIcon,
  growth_plans_custom_table: growthPlansIcon,
  competencies_custom_table: competenciesIcon,
  employee_onboarding: employeeOnboardingIcon,
  enps: enpsIcon,
  competencies: competenciesIcon,
  complaints: complaintsIcon,
  ats_whatsapp: atsWhatsapp,
  employee_chat_on_whatsapp: employeeChatWhatsApp,
  ats_ideal_disc_integration: atsIdealdisc,
}

export default ICONS
